(() => {
    (function ($) {
        $(document).ready(function () {

        console.log("=== BF2025: Page loaded ===");
        console.log("Kids/Adults bundle cards:", $(".bundles-kids-adult-content .slider-bundle-card").length);
        console.log("Pet bundle cards:", $(".bundles-pets-content .slider-bundle-card").length);
        console.log("Kids/Adults products:", $(".kids-adult-content .product-card, .kids-adult-content .product-card-v2").length);
        console.log("Pet products:", $(".pets-content .product-card, .pets-content .product-card-v2").length);

        // Note: .also-like-slider and .image-carousel are handled by product-card-2025.js
        // No need to initialize them here

        // Initialize Kids & Adults product slider
        $(".slider-kids-adults").slick({
            slidesToShow: 3,
            infinite: false,
            slidesToScroll: 1,
            nextArrow: $(".slider-cta .kids-adult-content .next-button"),
            prevArrow: $(".slider-cta .kids-adult-content .prev-button"),
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });

        // Initialize Pets product slider
        $(".slider-pets").slick({
            slidesToShow: 3,
            infinite: false,
            slidesToScroll: 1,
            nextArrow: $(".slider-cta .pets-content .next-button"),
            prevArrow: $(".slider-cta .pets-content .prev-button"),
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });

        // Category switching (Kids/Adults vs Pets)
		$(".category-btn").on("click", function () {
			console.log("=== BF2025: Category button clicked ===");
			console.log("Button classes:", $(this).attr("class"));

			$(".category-btn").removeClass("active");
			$(this).addClass("active");

			// Switch to Kids adults packs
			if ($(this).hasClass("kids-adult-btn")) {
				console.log("Switching to Kids/Adults content");
				$(".pets-content").removeClass("active");
				$(".kids-adult-content").addClass("active");
				$(".bundles-pets-content").removeClass("active");
				$(".bundles-kids-adult-content").addClass("active");

				console.log("Kids/Adults product content visible:", $(".kids-adult-content.active").length);
				console.log("Kids/Adults bundle content visible:", $(".bundles-kids-adult-content.active").length);
				console.log("Pet product content hidden:", $(".pets-content:not(.active)").length);
				console.log("Pet bundle content hidden:", $(".bundles-pets-content:not(.active)").length);
			}
			// Switch to Pets packs
			else if ($(this).hasClass("pets-btn")) {
				console.log("Switching to Pets content");
				$(".pets-content").addClass("active");
				$(".kids-adult-content").removeClass("active");
				$(".bundles-pets-content").addClass("active");
				$(".bundles-kids-adult-content").removeClass("active");

				console.log("Pet product content visible:", $(".pets-content.active").length);
				console.log("Pet bundle content visible:", $(".bundles-pets-content.active").length);
				console.log("Kids/Adults product content hidden:", $(".kids-adult-content:not(.active)").length);
				console.log("Kids/Adults bundle content hidden:", $(".bundles-kids-adult-content:not(.active)").length);
			}

			console.log("=== End category switch ===");
		});

        // Black Friday countdown timer
        const dateToCount = new Date("2026-01-05T23:59:00-06:00").getTime();

        const counter = setInterval(function() {
            const todayDate = new Date().getTime();

            const distance = dateToCount - todayDate;

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            document.getElementById("days").innerHTML = days;
            document.getElementById("hours").innerHTML = hours;
            document.getElementById("minutes").innerHTML = minutes;
            document.getElementById("seconds").innerHTML = seconds;

            if (distance < 0) {
                clearInterval(counter); 
                //document.getElementById("timer-list").innerHTML = "SORRY THE TIME IS OUT";
                document.getElementById("days").innerHTML = 0;
                document.getElementById("hours").innerHTML = 0;
                document.getElementById("minutes").innerHTML = 0;
                document.getElementById("seconds").innerHTML = 0;
            }
        }, 1000);


        let stockLevel = 55;
        let maxStock = 100;
        let firstIncreaseDone = false;
        let toastEnabled = false;

        const section = document.querySelector('.slider-bundles');
        const barFill = document.querySelector('.progress-fill');
        const percentText = document.querySelector('.percent-text');
        const addLabel = document.querySelector('.add-label');
        const stockToast = document.getElementById('stock-toast');

        function updateUI() {
        barFill.style.width = stockLevel + '%';
        if (percentText) percentText.textContent = stockLevel + '%';
        }

        function showToast() {
        if (!stockToast || !toastEnabled) return;
        stockToast.classList.add('active');
        setTimeout(() => stockToast.classList.remove('active'), 3000);
        }

        function showAddLabel() {
        if (!addLabel) return;
        addLabel.textContent = '(+1% added)';
          addLabel.style.display = 'inline-block';
        setTimeout(() => addLabel.style.display = 'none', 5000);
        showToast();
        }

        function increaseStock() {
        if (stockLevel >= maxStock) return;
        stockLevel++;
        updateUI();
        showAddLabel();
        }

        function onScroll() {
        const rect = section.getBoundingClientRect();
        if (!firstIncreaseDone && rect.top < window.innerHeight && rect.bottom > 0) {
            firstIncreaseDone = true;
            increaseStock(); 

            setTimeout(() => {
            toastEnabled = true;
            increaseStock();
            setInterval(increaseStock, 15000);
            }, 15000);
        }
        }

        updateUI();
        window.addEventListener('scroll', onScroll);


   });
 })(jQuery);
})()
